import { useEffect, useRef } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';

const ALLOWED_LANGS = ['en', 'he', 'ru', 'es'];

/**
 * Syncs UI language with the user record in the database.
 * - DB language wins when set to a non-default locale.
 * - Migrates an existing localStorage preference to the DB when the user still has the default.
 */
export default function LanguageSync() {
  const { user } = useAuth();
  const { language, setLanguage } = useLanguage();
  const migratedRef = useRef(false);

  useEffect(() => {
    if (!user?.id) return;

    const dbLang = ALLOWED_LANGS.includes(user.language) ? user.language : 'en';
    const storedLang = localStorage.getItem('lang');
    const stored = ALLOWED_LANGS.includes(storedLang) ? storedLang : 'en';

    if (dbLang !== 'en') {
      if (language !== dbLang) setLanguage(dbLang);
      return;
    }

    if (!migratedRef.current && stored !== 'en' && stored !== dbLang) {
      migratedRef.current = true;
      setLanguage(stored);
      axios.put('/api/users/me/language', { language: stored }).catch((err) => {
        if (process.env.NODE_ENV === 'development') {
          console.warn('[LanguageSync] Failed to migrate language preference', err);
        }
      });
    }
  }, [user?.id, user?.language, language, setLanguage]);

  return null;
}
